import PropTypes from "prop-types"
import CheckBox from "rc-checkbox"

const CheckboxWithTitle = ({ title, checked, onChange }) => {
  const onKeyUp = (e) => {
    if (e.keyCode && e.keyCode === 13) {
      onChange({ target: { checked: !checked } })
    }
  }

  const onClick = () => onChange({ target: { checked: !checked } })

  return (
    <div className="mx-auto mb-4 flex max-w-sm items-start justify-start text-primaryAccent">
      <CheckBox
        checked={checked}
        onClick={onClick}
        onChange={(e) => onChange(e)}
        className="mr-3 mt-1"
      />
      <div
        className="m-0 text-left text-sm font-light leading-5 text-secondary "
        role="button"
        tabIndex="0"
        onKeyUp={onKeyUp}
        onClick={onClick}
      >
        {title}
      </div>
    </div>
  )
}

export default CheckboxWithTitle

CheckboxWithTitle.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
}

CheckboxWithTitle.defaultProps = { checked: false }
